import styled from "styled-components"
import Button from "react-bootstrap/Button"

const DisabledButton = styled(Button)`
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
`
export default DisabledButton
